// @flow

import React, { Component } from 'react';
import {
  Button,
  EmailField,
  Section,
  Text,
  TextField,
  TextLink
} from 'seek-style-guide/react';
import { Field, withForm } from '@seek/forms-ui';
import {
  required,
  isEmail,
  maxLength,
  doesNotContain
} from '@seek/validators-js';
import { sendJobUrl } from 'src/config';

import styles from './SendJobForm.less';
const urlRegex = /[\d\w]{3,}\.[\w]{2,}/i;

type Props = {
  jobId: number,
  userName?: string,
  userEmail?: string,
  handleSubmit: Function,
  submit: Function,
  formErrorExists: boolean
};

class SendJobForm extends Component<Props> {
  props: Props;

  submit = formValues => {
    const { jobId } = this.props;

    this.props.submit({
      jobId,
      ...formValues
    });
  };

  requiredField() {
    return {
      ...required,
      getErrorMessage: ({ validatorProps: { label } }) =>
        `${label} can't be blank`
    };
  }

  mustNotContainUrl() {
    return {
      test: ({ value }) => !urlRegex.test(value),
      getErrorMessage: () => 'Must not contain website URLs'
    };
  }

  render() {
    const { jobId, handleSubmit, formErrorExists } = this.props;

    const nameFieldsValidation = {
      max: 25,
      forbiddenStrings: ['.', ':', '/']
    };

    return (
      <form
        onSubmit={handleSubmit(this.submit)}
        action={`${sendJobUrl}/${jobId}`}
      >
        <Section pullout>
          <Field
            form="sendJobForm"
            id="senderName"
            label="Your name"
            render={TextField}
            validators={[this.requiredField(), maxLength, doesNotContain]}
            validatorProps={{
              label: 'Your name',
              ...nameFieldsValidation
            }}
          />
          <Field
            form="sendJobForm"
            id="senderEmail"
            label="Your email"
            render={EmailField}
            validators={[this.requiredField(), isEmail]}
            validatorProps={{ label: 'Your email' }}
          />
          <Field
            form="sendJobForm"
            id="receiverName"
            label="Recipient's name"
            render={TextField}
            validators={[this.requiredField(), maxLength, doesNotContain]}
            validatorProps={{
              label: "Recipient's name",
              ...nameFieldsValidation
            }}
          />
          <Field
            form="sendJobForm"
            id="receiverEmail"
            label="Recipient's email"
            render={EmailField}
            validators={[this.requiredField(), isEmail]}
            validatorProps={{ label: "Recipient's email" }}
          />

          <Text secondary small className={styles.privacyStatement}>
            {
              'All personal information submitted by you will be used by us in accordance with our '
            }
            <TextLink href="/privacy">Privacy Statement</TextLink>.
          </Text>
        </Section>

        <Button type="submit" color="pink">
          {formErrorExists ? 'Try again' : 'Send'}
        </Button>
      </form>
    );
  }
}

export default withForm({
  name: 'sendJobForm'
})(SendJobForm);
